// make visual buttons work like buttons
document.querySelectorAll('[role=button], .btn').forEach((button) => {
  // js enhancement for "space" key on visual buttons
  button.addEventListener('keyup', function(e) {
    const keycode = e.keyCode || e.which;
    if (keycode == 32) {
      button.click();
    }
  });
});
